<template>
  <b-modal
      ref="modal"
      size="lg"
      centered
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      id="edit-other-task"
      title="Sửa tác vụ"
      hide-footer
      @show="getData()"
  >
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height:200px;">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <ValidationObserver v-else v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off" class="container px-0">
        <div class="row">
          <!-- Loại tác vụ -->
          <div class="col-md-6 mb-3">
            <label>Loại tác vụ <span class="text-danger">*</span></label>
            <el-input placeholder="Loại tác vụ" v-model="form.type" :disabled="true"></el-input>
          </div>

          <!-- Thời gian bắt đầu -->
          <div class="col-md-6 mb-3">
            <label>Thời gian bắt đầu làm việc <span class="text-danger">*</span></label>
            <ValidationProvider name="Thời gian bắt đầu" rules="required" v-slot="{ errors }">
              <date-picker
                  v-model="form.startAt"
                  type="datetime"
                  placeholder="Thời gian bắt đầu"
                  :time-picker-options="timePickerOptions"
                  format="DD-MM-YYYY HH:mm"
                  value-type="YYYY-MM-DD HH:mm:ss"
                  :disabled-date="disabledStartDate"
                  :disabled-time="disabledStartTime"
                  @change="resetWhenChangeStart"
              >
              </date-picker>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <!-- Thời gian kết thúc -->
          <div class="col-md-6 mb-3">
            <label>Thời gian kết thúc làm việc <span class="text-danger">*</span></label>
            <!-- Rule function theo đúng style VeeValidate Provider -->
            <ValidationProvider
                name="Thời gian kết thúc"
                :rules="endRules"
                v-slot="{ errors }"
            >
              <date-picker
                  v-model="form.endAt"
                  type="datetime"
                  placeholder="Thời gian kết thúc"
                  :time-picker-options="timePickerOptions"
                  format="DD-MM-YYYY HH:mm"
                  value-type="YYYY-MM-DD HH:mm:ss"
                  :disabled-date="disabledEndDate"
                  :disabled-time="disabledEndTime"
                  @change = "form.assigneeId = null"

              >
              </date-picker>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <!-- Người phụ trách -->
          <div class="col-md-6 mb-3">
            <label>Người phụ trách <span class="text-danger">*</span></label>
            <ValidationProvider name="Người phụ trách" rules="required" v-slot="{ errors }">
              <el-select v-model="form.assigneeId" placeholder="Chọn người phụ trách" class="w-100" filterable clearable :append-to-body="true" :disabled="!form.startAt || !form.endAt"   @focus="getTestersFrees" :loading="search_loading">
                <el-option
                    v-for="u in testers"
                    :key="u.id"
                    :label="`${u.name} - ${u.phone}`"
                    :value="u.id"
                />
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <!-- Đối tượng xử lý -->
          <div class="col-md-6 mb-1">
            <label>Đối tượng xử lý <span class="text-danger">*</span></label>
            <ValidationProvider name="Đối tượng xử lý" rules="required|max:99" v-slot="{ errors }">
              <el-input v-model="form.target" placeholder="Ví dụ: Workshop" clearable />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <el-button @click="hide()">Hủy</el-button>
          <el-button type="primary" class="ml-2" native-type="submit" :loading="submitting" :disabled="submitting">Cập nhật</el-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import moment from 'moment-timezone'
import {GET_TUTOR_DETAIL_TASK, GET_FREE_ADMIN, UPDATE_OTHER_TASK} from "@/core/services/store/tutor/tutor.module";
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
export default {
  name: 'EditOtherTask',
  components: {DatePicker},
  props: {
    task: { type: Object, default: () => {} }
  },
  data () {
    return {
      submitting: false,
      form: {
        id: null,
        type: null,
        startAt: '',
        endAt: '',
        assigneeId: null,
        target: ''
      },
      typeOptions: [
        { value: 'other', label: 'Tác vụ khác' },
        { value: 'call', label: 'Gọi điện' },
        { value: 'meeting', label: 'Họp' },
        { value: 'followup', label: 'Follow up' }
      ],
      search_loading: false,
      timePickerOptions: {
        start: '08:00',
        step: '00:15',
        end: '22:00',
        format: 'HH:mm'
      },
      testers: [],
      loading: false
    }
  },
  computed: {
    // Rule cho "kết thúc" viết đúng style Provider (object rule + function)
    endRules () {
      return {
        required: true,

      }
    }
  },
  methods: {
    hide () {
      this.$refs.modal.hide()
    },
    resetForm () {
      this.form = {
        id: null,
        type: 'other',
        startAt: '',
        endAt: '',
        assigneeId: null,
        target: ''
      }
    },
    syncEndIfInvalid () {
      if (this.form.endAt) {
        const s = moment(this.form.startAt, 'YYYY-MM-DD HH:mm:ss', true)
        const e = moment(this.form.endAt, 'YYYY-MM-DD HH:mm:ss', true)
        if (s.isValid() && e.isValid() && e.isAfter(s)) return
        // nếu không hợp lệ thì clear
        this.form.endAt = ''
      }
    },

    async onSubmit () {
      try {
        this.submitting = true
        let payload = {
          object_handle: this.form.target,
          admin_profile_id: this.form.assigneeId,
          start_date: this.form.startAt,
          end_date: this.form.endAt,
          id: this.form.id
        }
      await this.$store.dispatch(UPDATE_OTHER_TASK,payload)
        this.$notify({
          title: 'Success',
          message: 'Cập nhật thành công',
          type: 'success'
        });
        this.$emit('loadList')
        this.hide()

      }catch (e) {
        console.log(e)
        this.$notify.error({
          title: 'Error',
          message: `${e.data.message??'Đã có lỗi xẩy ra'}`
        });
      }finally {
        this.submitting = false
      }


    },
    async getData() {
      try {
        this.loading = true
        const res = await this.$store.dispatch(GET_TUTOR_DETAIL_TASK, this.task?.code)
        const data = res.data
        if (data) {
          const startAt = data.start_date
          const endAt   = data.end_date
          this.form = {
            id: data.id,
            type: data.type_label,
            startAt,
            endAt,
            assigneeId: data.admin_profile_id,
            target: data.handler || ''
          }
          this.testers = [{id: this.form.assigneeId, name: data.admin_profile_name, phone: data?.admin_profile_phone??'N/A' }]
        }

      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    disabledStartDate(date) {
      const today = moment().startOf('day');
      return moment(date) < today;
    },
    disabledStartTime(time){
      const formatTime = moment(time).format('HH:mm')
      const currentTime = moment().format('HH:mm')
      return moment(time) <  moment() || ("11:30" < formatTime && formatTime <= "13:30")
          || ("17:00" < formatTime && formatTime < "18:00")
          || ("21:45" < formatTime)
    },
    disabledEndDate(date) {
      return moment(date).endOf('days') <= moment(this.form.startAt);
    },
    disabledEndTime(time){
      const formatTime = moment(time).format('HH:mm')
      return moment(time) <  moment() || ("11:30" < formatTime && formatTime <= "13:30")
          || ("17:00" < formatTime && formatTime < "18:00")
          || ("21:45" < formatTime) || moment(this.form.startAt) >=  moment(time)
    },
    resetWhenChangeStart(){
      this.form.endAt = ''
      this.form.assigneeId = null
    },
    getTestersFrees() {
      if (!this.form.startAt || !this.form.endAt) {
        return;
      }
      let payload = {
        start_date: moment(this.form.startAt).format("YYYY-MM-DD HH:mm:ss"),
        end_date: moment(this.form.endAt).format("YYYY-MM-DD HH:mm:ss"),
      }
      this.search_loading = true;
      this.$store.dispatch(GET_FREE_ADMIN, payload).then((data) => {
        this.search_loading = false;
        this.testers = data.data;
      })
    },
  }
}
</script>

<style scoped>
:deep(.modal-content){ border-radius: 6px; }
:deep(.modal-body){ padding-top: 16px !important; padding-bottom: 8px !important; }
h5{ font-weight: 600; }
</style>
